import React from "react";
import "./styles/JobPostPage.css";
import CreateJobForm from "./createJobForm";

const JobPostPage = () => {
  return (
    <div className="job-post-page">
      <CreateJobForm />
    </div>
  );
};

export default JobPostPage;
